export default {"src":"/_next/static/media/bathrobe.0a274dec.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};